import { Formik, Form, useFormikContext } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import TextInput from '../../../shared/TextInput'
import CustomButton from '../../../shared/CustomButton'
import { FaCheckDouble } from 'react-icons/fa'
import DatePicker from '../../../shared/DatePicker'
import { useTranslation } from 'react-i18next'
import CheckPermission from '../../../hooks/CheckPermission'

const WriteOffForm = ({
  selectedItem,
  setOpenModal,
  setSelectedItem,
  rowIndex,
  setRowIndex
}) => {
  const { hasPermission } = CheckPermission()
  const { values, setFieldValue } = useFormikContext()
  const handleSubmit = (data, { setSubmitting, resetForm }) => {
    const action = selectedItem ? 'update' : 'create'
    if (!hasPermission('inventory', action)) return
    if (selectedItem) {
      const updatedItems = values.items.map((item, index) =>
        index === rowIndex ? data : item
      )
      setFieldValue('items', updatedItems)
    } else {
      setFieldValue('items', [...values.items, data])
    }
    setSubmitting(false)
    setOpenModal(false)
    setSelectedItem(null)
    resetForm()
  }
  const { t } = useTranslation()
  const validationSchema = Yup.object().shape({
    itemName: Yup.string().required(t('ItemNameisrequired')),
    writeOffQty: Yup.number()
      .required(t('Write-OffQtyisrequired'))
      .positive(t('Mustbepositive'))
      .integer(),
    writeOffDate: Yup.date().required(t('Write-OffDateisrequired')),
    remark: Yup.string().required(t('Remarkisrequired')),
    vat: Yup.number().min(0, t('VATcannotbenegative')),
    itemRate: Yup.number().min(0, t('Ratecannotbenegative'))
  })

  const initialValues = {
    itemName: selectedItem?.itemName || '',
    code: selectedItem?.code || '',
    availableQty: selectedItem?.availableQty || '',
    writeOffQty: selectedItem?.writeOffQty || '',
    writeOffDate: selectedItem?.writeOffDate || '',
    remark: selectedItem?.remark || '',
    itemRate: selectedItem?.itemRate || 0,
    subTotal: selectedItem?.subTotal || 0,
    vat: selectedItem?.vat || 0,
    totalAmount: selectedItem?.totalAmount || 0
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, isSubmitting }) => {
        const calculateTotals = () => {
          const subTotal =
            values.writeOffQty && values.itemRate
              ? values.writeOffQty * values.itemRate
              : 0
          const totalAmount =
            subTotal + (values.vat ? (subTotal * values.vat) / 100 : 0)
          setFieldValue('subTotal', subTotal.toFixed(2))
          setFieldValue('totalAmount', totalAmount.toFixed(2))
        }

        return (
          <Form className='grid grid-cols-1 gap-2 lg:grid-cols-3 md:grid-cols-2'>
            <TextInput
              name='itemName'
              label={t('ItemName')}
              placeholder={t('EnterItemName')}
              required
            />
            <TextInput
              name='code'
              label={t('Code')}
              placeholder={t('Code')}
              disabled
            />
            <TextInput
              name='availableQty'
              label={t('AvailableQty')}
              placeholder={t('AvailableQty')}
              disabled
            />
            <TextInput
              name='writeOffQty'
              label={t('Write-OffQty')}
              placeholder={t('EnterWrite-OffQty')}
              type='number'
              onBlur={calculateTotals}
              required
            />
            <DatePicker
              name='writeOffDate'
              label={t('Write-OffDate')}
              placeholder={t('SelectDate')}
              required
            />
            <TextInput
              name='remark'
              label={t('Remark')}
              placeholder={t('EnterRemark')}
              required
            />
            <TextInput
              name='itemRate'
              label={t('ItemRate')}
              placeholder={t('EnterRate')}
              type='number'
              onBlur={calculateTotals}
              disabled
            />
            <TextInput
              name='subTotal'
              label={t('SubTotal')}
              placeholder={t('SubTotal')}
              disabled
            />
            <TextInput
              name='vat'
              label={t('VAT%')}
              placeholder={t('EnterVAT%')}
              type='number'
              onBlur={calculateTotals}
              disabled
            />
            <TextInput
              name='totalAmount'
              label={t('TotalAmount')}
              placeholder={t('TotalAmount')}
              disabled
            />
            {hasPermission('inventory', selectedItem ? 'update' : 'create') && (
            <div className='col-span-3 flex justify-end items-center'>
              <CustomButton
                icon={FaCheckDouble}
                type='submit'
                label={t('Submit')}
                disabled={isSubmitting}
              />
            </div>
            )}
          </Form>
        )
      }}
    </Formik>
  )
}

export default WriteOffForm
